export default __webpack_public_path__ + "static/media/twitter (1) 1.e16dac2d.svg";